import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { useSelector } from "react-redux";
import { themes } from "../sass/themes";

export const ThemeManager = props => {
    const currentTheme = useSelector(state => state.currentTheme);

    const themesCss = {};
    for (let theme in themes)
         themesCss[theme]= `${process.env.PUBLIC_URL}/themes/${theme}-theme.css`;

    return (
        <ThemeSwitcherProvider
            themeMap={themesCss}
            defaultTheme={currentTheme.id}
            insertionPoint="styles-insertion-point">
                {props.children}
        </ThemeSwitcherProvider>
    );
};